import React from "react";
import heroVideo from "../../images/hero-video.mp4";
import Header5 from "../Header/Header5";
import SimpleSlider2 from "../Sliders/Slick-slider2";
import bg_vide from "../../videos/hero-video.mp4";
import Footer2 from "../Footer/Footer6";
function A4HFIRST() {
  return (
    <>
      <style>{`
        body, html {
    margin: 0;
    padding: 0;
  }

  .full-screen-block {
  position: relative;
  width: 100%;
  height: auto;
  overflow: visible;
}

.bg_video {
  width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center center;
  display: block;
}

  .hero-header {
    text-align: center;
    padding: 40px 20px;
    background: linear-gradient(to right, #ffdb5e 0%, #ffffff 100%);
    color: #e91f1f;
  }

  .hero-header h1{
    margin: 0;
    margin-bottom: 50px;
    font-size: 32px;
    font-weight: 900;
    letter-spacing: 1px;
  }

  .hero-header p{
  max-width: 1300px;
  margin: 25px auto;
  font-size: 18px;
  line-height: 1.9;
  color: #222;
  font-weight: 500;
  text-align: justify;
  padding: 0 40px;
  box-sizing: border-box;
}
.section-divider{
  width:100%;
  max-width:900px;
  margin:32px auto 38px;

  display:flex;
  align-items:center;
  justify-content:center;
  gap:18px;
}

.section-divider::before,
.section-divider::after{
  content:"";
  flex:1;
  height:3px;

  background: linear-gradient(
    to right,
    transparent,
    #1a2a5a,
    #d4af37,
    transparent
  );

  border-radius:10px;

  box-shadow:
    0 2px 6px rgba(0,0,0,0.18);
}

.section-divider span{
  font-size:26px;
  color:#1a2a5a;
  text-shadow:0 2px 6px rgba(0,0,0,0.15);

  animation: dividerGlow 2.5s ease-in-out infinite;
}
  @media (max-width: 768px) {

  .hero-header {
    padding: 30px 15px;
  }

  .hero-header h1{
    font-size: 18px;
    line-height: 1.2;
  }

  .hero-header h4{
    font-size: 14px;
    line-height: 1.25;
  }

  .hero-header p{
    font-size: 13px !important;
    line-height: 1.4;
    padding: 0 10px;
    text-align: left;
  }

  .section-divider span{
    font-size: 16px;
  }
}
      `}</style>


      <div  id="home" className="full-screen-block viewport-video-page"> 
        <video
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          disableRemotePlayback
          className="bg_video"
          onContextMenu={(e) => e.preventDefault()}
        >
                <source src={bg_vide} type="video/mp4"></source>
        </video> 
        
        <Header5/>
        <SimpleSlider2/>
      </div>

      {/* HEADER BELOW VIDEO */}
      <div className="hero-header">
  <h1>AMERICANS4HINDUS - POLITICAL ACTION COMMITTEE</h1>
    <div className="section-divider">
    <span>✦ ✦ ✦</span>
  </div>
  <h4>
    <strong>
      Empowering the Hindu American Voice Through Political Participation
    </strong>
  </h4>
  <p>
    The Americans4Hindus PAC (A4H PAC) was established to increase the political influence, representation, and civic engagement of Hindu Americans throughout the United States. As a bipartisan Political Action Committee, A4H PAC works to identify, support, and engage with public leaders who respect the values, concerns, and contributions of Hindu Americans and allied communities. Through endorsements, voter education, candidate engagement, and grassroots political participation, A4H PAC helps ensure that the Hindu American voice is represented in the democratic process at every level of government.
  </p>

  <p>
   The need for A4H PAC arises from a simple reality: communities that actively participate in the political process are better positioned to protect their interests, contribute to public policy discussions, and help shape the future of the nation. Hindu Americans have made extraordinary contributions to American society in business, healthcare, technology, education, public service, and philanthropy. A4H PAC exists to help transform that success into meaningful civic engagement and political empowerment.
  </p>
  <p>
    Through its nationwide network of state chapters, voter guides, candidate endorsements, public engagement initiatives, and leadership development efforts, A4H PAC is building one of the largest Hindu political participation movements in America. By encouraging informed voting, supporting qualified candidates, and strengthening relationships between communities and elected officials, A4H PAC seeks to empower future generations of Hindu Americans to become active participants and leaders in American democracy.
  </p>
</div>

     

<Footer2/>
      
    </>
  );
}

export default A4HFIRST;
